// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gnX7","top":"styles_top__2GW9r"};